import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';

const TrustSection = () => {
  const { t } = useTranslation();

  const trustElements = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      title: t('salescockpitPage.trust.guarantees.moneyBack.title'),
      description: t('salescockpitPage.trust.guarantees.moneyBack.description')
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      ),
      title: t('salescockpitPage.trust.guarantees.dataSecurity.title'),
      description: t('salescockpitPage.trust.guarantees.dataSecurity.description')
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: t('salescockpitPage.trust.guarantees.implementation.title'),
      description: t('salescockpitPage.trust.guarantees.implementation.description')
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      title: t('salescockpitPage.trust.guarantees.support.title'),
      description: t('salescockpitPage.trust.guarantees.support.description')
    }
  ];

  const industries = [
    t('salescockpitPage.trust.industries.items.fashion'),
    t('salescockpitPage.trust.industries.items.wholesale'),
    t('salescockpitPage.trust.industries.items.building'),
    t('salescockpitPage.trust.industries.items.automotive'),
    t('salescockpitPage.trust.industries.items.technology'),
    t('salescockpitPage.trust.industries.items.manufacturing')
  ];

  return (
    <section id="trust" className="py-20 bg-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-blue-900">
            {t('salescockpitPage.trust.title')}
          </h2>
          <p className="text-xl text-gray-700">
            {t('salescockpitPage.trust.subtitle')}
          </p>
        </div>

        {/* Garantien */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {trustElements.map((element, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="flex justify-center mb-5">
                {element.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-center text-gray-900">
                {element.title}
              </h3>
              <p className="text-gray-700 text-center">
                {element.description}
              </p>
            </div>
          ))}
        </div>

        {/* Branchen, in denen Salescockpit eingesetzt werden kann */}
        <div className="max-w-4xl mx-auto">
          <h3 className="text-2xl font-bold mb-8 text-center text-gray-900">
            {t('salescockpitPage.trust.industries.title')}
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
            {industries.map((industry, index) => (
              <div key={index} className="px-6 py-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow text-center">
                <span className="text-lg font-medium text-gray-800">{industry}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Abschließender CTA */}
        <div className="max-w-3xl mx-auto text-center mt-16">
          <div className="p-8 bg-blue-600 rounded-xl shadow-lg">
            <h3 className="text-2xl font-bold mb-4 text-white">
              {t('salescockpitPage.trust.finalCta.title')}
            </h3>
            <p className="text-lg text-blue-100 mb-8">
              {t('salescockpitPage.trust.finalCta.subtitle')}
            </p>
            <a 
              href="#contact"
              className="inline-block px-8 py-4 bg-white text-blue-600 text-lg font-semibold rounded-lg hover:bg-blue-50 transition-colors"
            >
              {t('salescockpitPage.trust.finalCta.buttonText')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection; 